import { IApi } from '../../api'
import { createRequestTypes } from '../../helpers/helpers'
import { createAction } from '../types'

export const prefix = 'feedback'

export const [CREATE_FEEDBACK_REQUEST, CREATE_FEEDBACK_SUCCESS, CREATE_FEEDBACK_FAILURE] =
  createRequestTypes(prefix, 'CREATE_FEEDBACK')

export const [LIST_FEEDBACK_REQUEST, LIST_FEEDBACK_SUCCESS, LIST_FEEDBACK_FAILURE] =
  createRequestTypes(prefix, 'LIST_FEEDBACK')

export const [GENERATE_FOLLOWUPS_REQUEST, GENERATE_FOLLOWUPS_SUCCESS, GENERATE_FOLLOWUPS_FAILURE] =
  createRequestTypes(prefix, 'GENERATE_FOLLOWUPS')

export const [ADD_FEEDBACK_INFO_REQUEST, ADD_FEEDBACK_INFO_SUCCESS, ADD_FEEDBACK_INFO_FAILURE] =
  createRequestTypes(prefix, 'ADD_FEEDBACK_INFO')

export const [
  LIST_FEEDBACK_FILES_REQUEST,
  LIST_FEEDBACK_FILES_SUCCESS,
  LIST_FEEDBACK_FILES_FAILURE,
] = createRequestTypes(prefix, 'LIST_FEEDBACK_FILES')

export const [
  LIST_FEEDBACK_SUBMITTERS_REQUEST,
  LIST_FEEDBACK_SUBMITTERS_SUCCESS,
  LIST_FEEDBACK_SUBMITTERS_FAILURE,
] = createRequestTypes(prefix, 'LIST_FEEDBACK_SUBMITTERS')

export const [
  CREATE_FEEDBACK_TICKET_REQUEST,
  CREATE_FEEDBACK_TICKET_SUCCESS,
  CREATE_FEEDBACK_TICKET_FAILURE,
] = createRequestTypes(prefix, 'CREATE_FEEDBACK_TICKET')

export const [
  GET_FEEDBACK_SUBMISSION_REQUEST,
  GET_FEEDBACK_SUBMISSION_SUCCESS,
  GET_FEEDBACK_SUBMISSION_FAILURE,
] = createRequestTypes(prefix, 'GET_FEEDBACK_SUBMISSION')

export const RESET_FEEDBACK_SUBMITTED = `${prefix}/RESET_FEEDBACK_SUBMITTED`

export const RESET_FEEDBACK_INFO = `${prefix}/RESET_FEEDBACK_INFO`

/** `attemptId` tells this attempt's eventual SUCCESS/FAILURE apart from a later attempt's. */
export const createFeedback = createAction((data: FormData, attemptId: string) => ({
  type: [CREATE_FEEDBACK_REQUEST, CREATE_FEEDBACK_SUCCESS, CREATE_FEEDBACK_FAILURE] as [
    string,
    string,
    string,
  ],
  promise: (api: IApi) => api.feedback.create(data),
  params: { attemptId },
}))

export const listFeedback = createAction((params?: object) => ({
  type: [LIST_FEEDBACK_REQUEST, LIST_FEEDBACK_SUCCESS, LIST_FEEDBACK_FAILURE] as [
    string,
    string,
    string,
  ],
  promise: (api: IApi) => api.feedback.list(params),
  params,
}))

export const generateFollowUps = createAction(
  (payload: { title: string; description: string; pageUrl?: string; screenshotData?: string }) => ({
    type: [GENERATE_FOLLOWUPS_REQUEST, GENERATE_FOLLOWUPS_SUCCESS, GENERATE_FOLLOWUPS_FAILURE] as [
      string,
      string,
      string,
    ],
    promise: (api: IApi) => api.feedback.followUps(payload),
  }),
)

export const addFeedbackInfo = createAction((data: { id: string; text: string }) => ({
  type: [ADD_FEEDBACK_INFO_REQUEST, ADD_FEEDBACK_INFO_SUCCESS, ADD_FEEDBACK_INFO_FAILURE] as [
    string,
    string,
    string,
  ],
  promise: (api: IApi) => api.feedback.addInfo(data),
  params: data,
}))

export const listFeedbackFiles = createAction((id: string) => ({
  type: [LIST_FEEDBACK_FILES_REQUEST, LIST_FEEDBACK_FILES_SUCCESS, LIST_FEEDBACK_FILES_FAILURE] as [
    string,
    string,
    string,
  ],
  promise: (api: IApi) => api.feedback.listFiles(id),
  params: { id },
}))

// One submission by id, for its detail modal outside the Feedback page. Lands in the by-id cache.
export const getFeedbackSubmission = createAction((id: string) => ({
  type: [
    GET_FEEDBACK_SUBMISSION_REQUEST,
    GET_FEEDBACK_SUBMISSION_SUCCESS,
    GET_FEEDBACK_SUBMISSION_FAILURE,
  ] as [string, string, string],
  promise: (api: IApi) => api.feedback.list({ id }),
  params: { id },
}))

// Everyone who has submitted feedback, for the Submitter filter. Read straight off the promise.
export const listFeedbackSubmitters = createAction(() => ({
  type: [
    LIST_FEEDBACK_SUBMITTERS_REQUEST,
    LIST_FEEDBACK_SUBMITTERS_SUCCESS,
    LIST_FEEDBACK_SUBMITTERS_FAILURE,
  ] as [string, string, string],
  promise: (api: IApi) => api.feedback.listSubmitters(),
}))

export const createFeedbackTicket = createAction((id: string) => ({
  type: [
    CREATE_FEEDBACK_TICKET_REQUEST,
    CREATE_FEEDBACK_TICKET_SUCCESS,
    CREATE_FEEDBACK_TICKET_FAILURE,
  ] as [string, string, string],
  promise: (api: IApi) => api.feedback.createTicket(id),
  params: { id },
}))

/**
 * Ends a submit the widget has given up waiting on. Reuses CREATE_FEEDBACK_FAILURE so the
 * existing reducers do the work — `loadingArray` drops the pending request and `submitError`
 * shows the message, which together restore a usable form. The attempt's id retires it, so what
 * the abandoned request eventually answers is dropped rather than landing on its replacement.
 */
export const failFeedbackSubmit = (message: string, attemptId: string) => ({
  type: CREATE_FEEDBACK_FAILURE,
  error: new Error(message),
  params: { attemptId, isLocal: true },
})

export const resetFeedbackSubmitted = () => ({
  type: RESET_FEEDBACK_SUBMITTED,
})

export const resetFeedbackInfo = () => ({
  type: RESET_FEEDBACK_INFO,
})
